module.exports = __webpack_public_path__ + "static/media/plus.41afe0dc.svg";